import { render, staticRenderFns } from "./MfaInput.vue?vue&type=template&id=2a6c4fcd&"
import script from "./MfaInput.ts?vue&type=script&lang=ts&"
export * from "./MfaInput.ts?vue&type=script&lang=ts&"
import style0 from "./MfaInput.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports